/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function packageProtection() {
  $("body").on("change", "[data-package-protection]", function (e) {
    e.preventDefault();
    if ($(this).is(":checked")) {
      var params = {
        type: "POST",
        url: "/cart/add.js",
        data:
          "quantity=" +
          1 +
          "&properties[package]=true&id=" +
          $(this).attr("data-package-protection"),
        dataType: "json",
        success: function (line_item) {
          console.log("Added product!");
        },
        error: function (XMLHttpRequest, textStatus) {
          alert("Product currently not available!");
        },
      };
      jQuery.ajax(params);
      return false;
    } else {
      var params = {
        type: "POST",
        url: "/cart/change.js",
        data:
          "quantity=" + 0 + "&id=" + $(this).attr("data-package-protection"),
        dataType: "json",
        success: function (line_item) {
          console.log("Removed product!");
        },
        error: function (XMLHttpRequest, textStatus) {
          console.log("Error Occurred!");
        },
      };
      jQuery.ajax(params);
      return false;
    }
  });
}
packageProtection();

document.addEventListener("DOMContentLoaded", () => {
  let currentSelectedVariant = null;

  $(document).on("click", ".hktqv_Product__InlineOption__Value", () => {
    let variant_values = [];
    $(".hktqv_Product__InlineOption__Value--Selected").each((i, el) => {
      const variant_value = $(el).attr("value");
      if (variant_value && variant_value.length > 0)
        variant_values.push(variant_value);
    });
    const product_data = JSON.parse(
      $(".hktqv_show[data-product]").attr("data-product")
    );
    const product_variants = product_data.variants;
    const current_product_variant = variant_values.join(" / ");
    const current_product_variant_data = product_variants.find(
      (variant) => variant.title == current_product_variant
    );

    if (
      current_product_variant == undefined ||
      (current_product_variant && current_product_variant.available == true)
    )
      $(".hktqv_Product__Availability").removeClass("Error").text("");

    if (current_product_variant_data == undefined) {
      $(".hktqv_Product__Availability").addClass("Error").text("Unavailable");
    }
    currentSelectedVariant = current_product_variant_data;
  });

  $(document).on("click", ".hktqv_Trigger__QuickView", () => {
    currentSelectedVariant = null;

    const oldButton = document.querySelector(
      ".hktqv_Product__CTA__AddToCart__Btn"
    );
    if (oldButton) {
      const newButton = oldButton.cloneNode(true);
      oldButton.parentNode.replaceChild(newButton, oldButton);
    }
    let intervalIncr = 0;
    const interval = setInterval(() => {
      $(".hktqv_Product__InlineOption__Value--Selected").trigger("click");
      if (currentSelectedVariant && currentSelectedVariant.id && intervalIncr > 5) {
        clearInterval(interval)
      }
      intervalIncr++;
    }, 500) 
    $(document).on("click", ".hktqv_Product__CTA__AddToCart__Btn", () => {
      var quantityElement = $(
        ".hktqv_Product__CTA__AddToCart__QuantityForm--Input"
      );
      $(".hktqv_Product__CTA__AddToCart__Btn").addClass("hktqv_Spinner");
      fetch("".concat(window.routes.cartAddUrl, ".js"), {
        body: JSON.stringify({
          form_type: "product",
          utf8: "✓",
          id: currentSelectedVariant.id,
          quantity: quantityElement ? parseInt(quantityElement.val()) : 1,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));  
        $(".hktqv_Product__CTA__AddToCart__Btn").removeClass("hktqv_Spinner");
      });
    });
  });
});
